import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Result, Select } from 'antd';
import 'antd/dist/antd.css';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import jsonpath from 'jsonpath'

import { faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp, faCamera } from '@fortawesome/free-solid-svg-icons';
import ImageView from '../ImageView/ImageView';
const DataEntryReportView = ({ pdfData = {}, obj = {}, item = {}, ChecksheetType, config = {}, QualityData = [] }) => {
    const filterViewData = QualityData.filter(one => one.InspectionType === obj.InspectionType);
    const [filteredQualityData, setFilteredQualityData] = useState([]);
    const filterQualityDataByFields = (obj, QualityData) => {
        if (QualityData.length === 0) return [];

        // Get the customField values from the first item to use as a reference
        const firstItem = QualityData[0];
        const referenceValues = obj.map(fieldName => {
            const field = firstItem.customFields.find(f => f.FieldName === fieldName);
            return field && field.Value;
        });

        // If we don't find all field values in the first item, return an empty array
        if (referenceValues.includes(undefined)) return [];

        // Filter the QualityData array based on these reference values
        const filteredData = QualityData.filter(dataItem => {
            return obj.every((fieldName, index) => {
                const field = dataItem.customFields.find(f => f.FieldName === fieldName);
                return field && field.Value === referenceValues[index];
            });
        });
        setFilteredQualityData(filteredData);
        return filteredData;
    };
    const NotgroupableFields = config.CustomFields
        .filter(field => field.FieldName.startsWith("Date_") || !field.UsedForGroupBy)  // Filter out fields where UsedForGroupBy is false
        .map(field => field.FieldName);
    const groupableFields = config.CustomFields
        .filter(field => field.UsedForGroupBy)  // Filter out fields where UsedForGroupBy is false
        .map(field => field.FieldName);          // Map only the FieldName of the remaining fields
    // UseEffect to call the filter function when the component loads or when relevant props/state change
    useEffect(() => {
        // Call the filtering function (use actual obj and QualityData values from your props or state)
        if (groupableFields && groupableFields.length > 0 && filterViewData && filterViewData.length > 0) { filterQualityDataByFields(groupableFields, filterViewData) }
        else {
            //Chnage 
            setFilteredQualityData(QualityData);
        }

    }, []); // You can include `obj` and `QualityData` in the dependency array if they are dynamic
    console.log(filteredQualityData, "dshfbsdhf", filterViewData)
    const history = useHistory();
    const location = useLocation();

    const [qualityData, setQualityData] = useState([])
    const [inputData, setInputData] = useState({ DateTime: new Date(), Instrument: [] })
    const [loader, setLoader] = useState(false)
    const [NumberOfSample, setNumberOfSample] = useState(0)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [ModalImage, setModalImage] = useState('');
    const [List, setList] = useState([]);
    const [templateList, setTemplateList] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] })

    const [instruments, setInstruments] = useState([]);
    const [types, setTypes] = useState([]);

    useEffect(() => {
        if (templateList.length > 0) {
            getAllTypes()
            getAllInstrument()
            initializedData()

        }
    }, [obj, templateList, item])

    useEffect(() => {
        getListNames()
        getAllcheckPointConfig()
    }, [])

    const getAllcheckPointConfig = () => {
        axios.get(api.api + "checkPointConfig")
            .then((result) => {
                setTemplateList(result.data)
            })
            .catch((err) => {
                swal(`${err}`);
            })
    }



    const getAllTypes = () => {
        axios.get(api.api + 'instrumentType')
            .then((result) => {
                setTypes(result.data.map((x) => { return { label: x.InstrumentType, value: x.InstrumentType, _id: x._id } }))
            })
            .catch((err) => {
                swal(`${err}`)
            })
    }

    const getAllInstrument = () => {
        axios.get(api.api + 'instrument')
            .then((result) => {
                setInstruments(result.data.map((x) => { return { type: x.InstrumentType, label: x.Instrument, value: x.Instrument, _id: x._id } }))
            })
            .catch((err) => {
                swal(`${err}`)
            })
    }

    const getColumns = (TemplateName) => templateList.find(x => x.Name == TemplateName) ? templateList.find(x => x.Name == TemplateName).Columns.filter(x => x.EnableForDataEntry) : [];
    const getColumnsAll = (TemplateName) => templateList.find(x => x.Name == TemplateName) ? templateList.find(x => x.Name == TemplateName).Columns : [];


    const initializedData = () => {
        const cloneItem = cloneDeep(item)
        const checkSheet = cloneItem.Inspection && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
        if (checkSheet && !checkSheet.checkSheetTitle) {
            swal(`Do not have checkpoints for ${ChecksheetType} `, { dangerMode: true })
            history.goBack();
        } else {
            if (checkSheet && checkSheet.checkSheetTitle && checkSheet.checkSheetTitle && checkSheet.checkSheetTitle.length > 0) {
                const template = templateList.find(x => checkSheet.checkSheetTitle.some(a => a.TemplateName == x.Name));
                if (template) {
                    setSelectedTemplate(template)
                    // setSelectedColumns(template.Columns.filter(col => col.EnableForDataEntry) || [])
                }
                const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)

                // checkSheet.checkSheetTitle.checkpoints.forEach((x) => {
                //     x.Result = default1.TreatAs;
                // })
                const mapData = checkSheet.checkSheetTitle.map(check => { return { CheckSheetName: check.check_sheet_title, TemplateName: check.TemplateName, Drawing: check.Drawing, Samples: [{ Standard: check.checkpoints }] } })

                setQualityData(mapData);
                setNumberOfSample(checkSheet.checkSheetTitle.reduce((total, x) => total + x.NumOfSamples, 0))
                // setFinalResult([{ Standard: checkSheet.checkSheetTitle.checkpoints }])
            }

        }
    }

    const inputRef = useRef(null);
    useEffect(() => {
        initializedInputFocus()
    }, []);

    const initializedInputFocus = () => {
        // Ensure the focus happens after the component has mounted
        const timer = setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 0);

        return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }




    const handleModalClose = () => {
        setIsModalVisible(false);
    };


    const handleOnChange = (name, value, index) => {

        setInputData(prev => {
            const newData = { ...prev };

            // Ensure CustomFields is initialized as an array
            if (!newData.CustomFields) {
                newData.CustomFields = [];
            }

            // Ensure the specific index is initialized as an object
            if (!newData.CustomFields[index]) {
                newData.CustomFields[index] = {};
            }

            newData.CustomFields[index]['FieldName'] = name;
            newData.CustomFields[index]['Value'] = value;


            return newData;
        });
    };

    function extractData(json, path) {
        if (json) {
            const result = jsonpath.query(json, path);
            return result;
        }
        return ""
    }


  const handelfinalResult = (data = []) => {
    console.log(data, "cdsjbchsdc");
    const everyOK = data.every((one) => one.Result === "OK");
    const someOKsomeNA = data.every((one) => one.Result === "OK" || one.Result === "NA");
    const everyNA = data.every((one) => one.Result === "NA");
    const everyNG = data.every((one) => one.Result === "NG");
    const NG = data.filter((one) => one.Result === "NG");
    // console.log(data.length, OK.length, "geurburb");
    if (everyOK || (someOKsomeNA && !everyNA)) {
      return "OK";
    }
    if (everyNG || everyNA || NG.length > 0) {
      return "NG";
    }
  };

    const handleOnChangeDateTime = (type, value) => {
        let newDateTime;
        if (type === 'date') {
            // Update date part, keep time part
            const currentMoment = moment(inputData.DateTime);
            newDateTime = moment(value + "T" + currentMoment.format('HH:mm')).toDate();
        } else if (type === 'time') {
            // Update time part, keep date part
            const currentMoment = moment(inputData.DateTime);
            newDateTime = moment(currentMoment.format('YYYY-MM-DD') + "T" + value).toDate();
        }
        // handleOnChange("DateTime",newDateTime)
        setInputData({ ...inputData, DateTime: newDateTime });
    };

    const getDataTypeElement = (parentIdx, currentIdx, field, data) => {
        const dimensionTypes = ["Dimension+Tolerance", "Dimension-Tolerance", "StandardDimension"];
        if ((data.StandardType == "Description") && dimensionTypes.includes(field.DataType)) {
            return <></>
        }
        switch (field.DataType) {
            case 'UserInputDecision':
                if (data.StandardType == "Dimension") {
                    const plusCol = selectedTemplate.Columns.find(x => x.DataType == "Dimension+Tolerance");
                    const minusCol = selectedTemplate.Columns.find(x => x.DataType == "Dimension-Tolerance");
                    const standardNum = selectedTemplate.Columns.find(x => x.DataType == "StandardDimension");
                    return (
                        <div >
                            <input
                                disabled
                                onBlur={() => {
                                    const observedValue = parseFloat(data[field.DbFieldName])
                                    const plusValue = parseFloat(data[plusCol.DbFieldName])
                                    const minusValue = parseFloat(data[minusCol.DbFieldName])
                                    const standardValue = parseFloat(data[standardNum.DbFieldName])
                                    const plus =
                                        standardValue +
                                        parseFloat(
                                            plusValue
                                        );
                                    const minus =
                                        standardValue -
                                        parseFloat(
                                            minusValue
                                        );
                                    const data1 = [
                                        ...qualityData,
                                    ];
                                    if (data1[parentIdx].Standard[currentIdx][field.DbFieldName])
                                        data1[
                                            parentIdx
                                        ].Standard[currentIdx][
                                            "Result"
                                        ] = "NG";
                                    if (
                                        minus <= observedValue &&
                                        observedValue <= plus
                                    ) {
                                        data1[
                                            parentIdx
                                        ].Standard[currentIdx][
                                            "Result"
                                        ] = "OK";
                                    }
                                    setQualityData(data1);
                                }}
                                type="text"
                                className="form-control form-control-sm p-0 text-center"
                                id={field.DbFieldName}
                                name={field.DbFieldName}
                                placeholder={field.placeholder || ''}
                                value={data[field.DbFieldName] || ""}
                            />
                        </div>
                    );
                }
                if (data.StandardType == "Description") {
                    return (
                        <div className='text-center d-flex'>
                            {config.ResultConfigure && config.ResultConfigure.map((x, index) => {
                                return <label className={index > 0 ? "ml-3" : ""}>
                                    <input
                                        disabled
                                        className='mt-1'
                                        type="radio"
                                        name={field.DbFieldName + parentIdx + currentIdx}
                                        value="OK"
                                        checked={data.Result === x.TreatAs}
                                    />
                                    &nbsp;{x.Result}
                                </label>
                            })}

                        </div>
                    );
                } else { return 'NA' }
            case 'UserInputNumber':
                return (
                    <div >
                        <input
                            disabled
                            type="number"
                            className="form-control form-control-sm p-0 text-center"
                            id={field.DbFieldName}
                            name={field.DbFieldName}
                            placeholder={field.placeholder || ''}
                            onChange={handleOnChange}
                            value={data[field.DbFieldName] || ""}
                        />
                    </div>
                );
            case 'UserInputString':
                return (
                    <div >
                        <input
                            disabled
                            type="text"
                            className="form-control form-control-sm p-0"
                            id={field.DbFieldName}
                            name={field.DbFieldName}
                            value={data[field.DbFieldName] || ""}
                            placeholder={field.placeholder || ''}
                        />
                    </div>
                );
            case 'ConstantString':
                return (
                    <div>
                        <p className='custom-paragraph'>{data[field.DbFieldName] || ""}</p>

                    </div>
                );
            case 'StandardDimension':
                return (
                    <div >
                        <input
                            disabled
                            type="number"
                            value={data[field.DbFieldName] || ""}
                            className="form-control form-control-sm p-0 text-center"
                            id={field.DbFieldName}
                            name={field.DbFieldName}
                            placeholder={field.placeholder || ''}
                            onChange={handleOnChange}
                        />
                    </div>
                );
            case 'Dimension+Tolerance':
                return (
                    <div >
                        <input
                            disabled
                            type="number"
                            value={data[field.DbFieldName] || ""}
                            className="form-control form-control-sm p-0 text-center"
                            id={field.DbFieldName}
                            name={field.DbFieldName}
                            placeholder={field.placeholder}
                            onChange={handleOnChange}
                        />
                    </div>
                );
            case 'Dimension-Tolerance':
                return (
                    <div >
                        <input
                            disabled
                            type="number"
                            value={data[field.DbFieldName] || ""}
                            className="form-control form-control-sm p-0 text-center"
                            id={field.DbFieldName}
                            name={field.DbFieldName}
                            placeholder={field.placeholder}
                            onChange={handleOnChange}
                        />
                    </div>
                );
            default:
                return <></>;
        }
    }

    const getListNames = () => {
        axios.get(api.api + 'ListMaster')
            .then((result) => {
                // consol(result.data)
                setLoader(false)
                setList(result.data);
            })
            .catch((err) => {
                swal(`${err}`)
                setLoader(false)
            })
    }

    const getQualityData = (obj1, sheet) => {
        const checkSheets = obj1 && obj1.sampleRef && obj1.sampleRef.filter(x => x.CheckSheetName == sheet.check_sheet_title).map((checkRef, idx) => {
            let deepClonedChecksheet = JSON.parse(JSON.stringify(obj1.Checksheet));
            deepClonedChecksheet = deepClonedChecksheet && deepClonedChecksheet.filter(item => item.CheckSheetName == checkRef.CheckSheetName)
            deepClonedChecksheet.forEach((check) => {
                const keys = check.Data[idx]?Object.keys(check.Data[idx]):[];
                keys.forEach((key) => {
                    check[key] = check.Data[idx][key];
                });
            });
            return {IsNA: checkRef.IsNA, IsNARemarks: checkRef.IsNARemarks, Sample: checkRef.Sample, SetName: checkRef.SetName, Standard: deepClonedChecksheet };
        });
        return checkSheets
    }


    const getQualityDataForArray = (sheet, groupKey) => {
        let finalData = [];
        if (pdfData[groupKey] && pdfData[groupKey][config.InspectionType]) {
            const arr = [...pdfData[groupKey][config.InspectionType]]
            arr.forEach((obj) => {
                obj.sampleRef.forEach((sample) => {
                    const cloneObj = cloneDeep(obj);
                    cloneObj.Sample = sample
                    finalData.push(cloneObj)
                })
            })
        }
        return finalData;
    };

    const getNextSample = (input) => {
        // Separate the string and number
        const match = input.match(/([a-zA-Z]+)(\d+)/);

        if (match) {
            const stringPart = match[1]; // "Sample"
            const numberPart = parseInt(match[2], 10); // 1

            // Increment the number
            const incrementedNumber = numberPart + 1;

            // Combine the string part with the incremented number
            return numberPart; // "Sample2"
        } else {
            return 0; // Return the original input if no match is found
        }
    }


    function openBase64InNewTab(base64String, fileType = 'application/pdf') {
        // Create a new window or tab with the base64 data
        const newTab = window.open();
        let content = '';
        // Format the base64 string as a data URL with the correct MIME type
        if (base64String.startsWith("data:image/")) {
            content = `<img src="${base64String}" style="width:100%; height:100%; border:none;" />`;
        } else {
            content = `
            <iframe 
              src=${base64String}
              style="border:none; width:100%; height:100%;" 
            ></iframe>
          `;
        }
        newTab.document.write(content);
    }

    let printedSetNames = [];

    const renderSetName = (sample) => {
        // If SetName hasn't been printed, print it and add it to the array
        if (!printedSetNames.includes(sample.SetName)) {
            printedSetNames.push(sample.SetName);
            if (sample.SetName) {
                return <h4 style={{ fontSize: 15, marginTop: 15 }}>Set Name - {sample.SetName}</h4>;
            }
            return <></>
        }
        // Otherwise, return null to avoid duplicate printing
        return null;
    };



    const getRefDocs = () => {
        let docs = []
        if (groupableFields.length > 0) {
            filteredQualityData.forEach((x => {
                docs = [...x.RefDocs, ...docs]
            }))
        } else {
            docs = obj.RefDocs;
        }
        return docs;
    }

    function arrangeStrings(arr, stringA, stringB) {
        // Remove stringA and stringB from the array if they exist
        if (arr.length == 0) {
            return arr;
        }
        const filteredArray = arr.filter(item => item !== stringA && item !== stringB);

        // Find the index of the first occurrence of stringA or stringB in the original array
        const firstIndex = arr.indexOf(stringA) < arr.indexOf(stringB) ? stringA : stringB;
        const secondIndex = firstIndex === stringA ? stringB : stringA;

        // Insert the two strings in the correct order
        const resultArray = [...filteredArray];
        const insertIndex = arr.indexOf(firstIndex); // Insert at the original position of the first string
        resultArray.splice(insertIndex, 0, firstIndex, secondIndex);

        return resultArray;
    }


    const AccordianComp = (sheet, id) => {
        const { Drawing, check_sheet_title } = sheet
        const panelId = `panel-${id}`; // Unique ID for the panel
        const headerId = `header-${id}`; // Unique ID for the header
        return (
            <div className="accordion-item border-0">
                <h2 style={{ width: '99%', padding: '12px' }} className="accordion-header" id={headerId}>
                    <button
                        style={{
                            "border": "solid 1px lightgray",
                            borderRadius: 10
                        }}
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${panelId}`} // Target the unique panel ID
                        aria-expanded="false"
                        aria-controls={panelId}
                    >
                        {check_sheet_title}
                    </button>
                </h2>
                <div
                    style={{ paddingBottom: '34px' }}
                    id={panelId}
                    className="accordion-collapse collapse show"
                    aria-labelledby={headerId}
                    data-bs-parent="#accordionParent" // Ensures only one is open at a time
                >
                    <div className="accordion-body">
                        {Drawing && <img width={'100%'} height={600} src={Drawing} title='drawing' />}
                        {renderComponent(sheet)}
                    </div>
                </div>
            </div>
        );
    };

    const groupByField = () => config && config.CustomFields ? config.CustomFields.filter(x => x.UsedForGroupBy).map(x => x.FieldName) : [];
    const nonGroupByField = () => config && config.CustomFields ? config.CustomFields.filter(x => !x.UsedForGroupBy).map(x => x.FieldName) : [];




    const renderComponent = (sheet) => {
        console.log("renderComponent", getQualityData(obj, sheet),obj,sheet)
        return false && groupByField().length > 0 && Object.keys(pdfData).length > 0 ?
            <>
                {Object.keys(pdfData).map(key => {
                    return <React.Fragment>
                        {/* {renderSetName(doc.Sample)} */}
                        {/* <h4 style={{ fontSize: 15, marginTop: 15 }}>Sample Serial :{config.SampleSerial == "Auto" && config.SampleSerialUnique == "No" ? "Sample #" + (parentIdx + 1) : getNextSample(doc.Sample.Sample)}</h4> */}
                        <table style={{ width: '100%' }} className="small table-sm table-responsive table-bordered">
                            <thead className='text-center' >
                                <tr style={
                                    { backgroundColor: "#DCDCDC", padding: 0 }}>
                                    <th colSpan={getColumns(sheet.TemplateName).filter(col => col.DataType === "ConstantString").length} rowSpan={nonGroupByField().length + 4} className="text-center bolder">
                                        {groupByField().length > 0 &&
                                            groupByField().map((one, dx) => (
                                                <div key={dx}> {one.startsWith("Date_") ? "Date" : one} :
                                                    {one.startsWith("Date_") ? moment(new Date(extractData(obj, `$..customFields[?(@.FieldName=="${one}")].Value`))).format('DD-MM-YYYY') : key}
                                                </div>
                                            ))
                                        }
                                    </th>
                                    <th colSpan={1} rowSpan={1} className='text-center bolder'>Sample</th>
                                    {getQualityDataForArray(sheet, key).map(one =>
                                        <td style={
                                            { backgroundColor: "#B6B6B4", padding: 0 }} colSpan={getColumnsAll(sheet.TemplateName).filter(col => col.DataType == "UserInputNumber" || col.DataType == "UserInputString" || col.DataType == "UserInputDecision").length}>{one && one.Sample && one.Sample.Sample} </td>)}
                                </tr>
                                <tr style={
                                    { backgroundColor: "#DCDCDC", padding: 0 }} >
                                    <th>Time</th>
                                    {getQualityDataForArray(sheet, key).map(one => <td colSpan={getColumnsAll(sheet.TemplateName).filter(col => col.DataType == "UserInputNumber" || col.DataType == "UserInputString" || col.DataType == "UserInputDecision").length}>{moment(one.DateTime).format('HH:mm')}</td>)}
                                </tr>
                                {arrangeStrings(nonGroupByField(), "Shift Event", "Date_Shift").map(field => <tr>
                                    <th colSpan={1} rowSpan={1} className='text-center bolder'>{field.startsWith("Date_") ? "Date" : field} </th>
                                    {getQualityDataForArray(sheet, key).map(one => <td colSpan={getColumns(sheet.TemplateName).filter(col => col.DataType == "UserInputNumber" || col.DataType == "UserInputString" || col.DataType == "UserInputDecision").length}>{field.startsWith("Date_") ? moment(new Date(extractData(obj, `$..customFields[?(@.FieldName=="${field}")].Value`))).format('DD-MM-YYYY') : extractData(obj, `$..customFields[?(@.FieldName=="${field}")].Value`)}
                                    </td>)}
                                </tr>
                                )}

                                <tr style={
                                    { backgroundColor: "#DCDCDC", padding: 0 }}>
                                    {getColumns(sheet.TemplateName).map(((x, xindex) => x.FieldName != 'Image' && <th colSpan={xindex == 0 ? 2 : 1}>{x.FieldName}</th>))}

                                    {getQualityDataForArray(sheet, key).map((x, idx) => {
                                        if (idx > 0) {
                                            let cols = getColumns(sheet.TemplateName).filter(x => x.DataType.startsWith('UserInput'))
                                            cols = cols.map(x => x.FieldName != 'Image' && <th colSpan={1}>{x.FieldName}</th>)
                                            return cols
                                        }
                                    })}
                                </tr>
                            </thead>
                            {/* <tbody className='text-center'>
                                {sample && sample.Standard && sample.Standard.map((one, index) => {
                                    return (
                                        <tr
                                            style={
                                                { backgroundColor: "#DCDCDC", padding: 0 }
                                            }
                                            key={index}>
                                            {getColumns(sheet.TemplateName).filter((x) => x.DataType == "ConstantString").map(((x, xindex) => <td colSpan={xindex == 0 ? 2 : 1} >{getDataTypeElement(parentIdx, index, x, one)}</td>))}
                                            {getQualityDataForArray(sheet).map((data, idx) => {
                                                // if (idx > 0) {
                                                const color = config.ResultConfigure.find(x => data[parentIdx] && data[parentIdx].Standard[index] && x.TreatAs == data[parentIdx].Standard[index].Result)

                                                let cols = getColumns(sheet.TemplateName).filter(x => x.DataType.startsWith('UserInput'))
                                                cols = cols.map(x1 => {
                                                    if (data[parentIdx] && data[parentIdx].Standard && data[parentIdx].Standard[index]) {
                                                        return <td style={
                                                            { backgroundColor: color ? color.Color : "yellow", padding: 0 }
                                                        }>{getDataTypeElement(parentIdx, index, x1, data[parentIdx].Standard[index])}</td>
                                                    }
                                                })
                                                return cols
                                                // }
                                            })}
                                        </tr>

                                    );
                                })}
                                <tr>
                                    {filteredQualityData.length > 0 ? filteredQualityData.map((x, idx) => {
                                        const result = x.sampleRef.find(c => c.Sample == sample.Sample)
                                        return (<>
                                            {idx == 0 && <td style={
                                                { backgroundColor: "#DCDCDC", padding: 0 }} className='border' colSpan={getColumns(sheet.TemplateName).filter(col => col.DataType === "ConstantString").length + 1}></td>}
                                            {getColumns(sheet.TemplateName).map((x => x.FieldName != 'Image')) && <td colSpan={getColumns(sheet.TemplateName).filter(col => col.DataType == "UserInputNumber" || col.DataType == "UserInputString" || col.DataType == "UserInputDecision").length} className='p-2 text-white fw-bold table-bordered' style={{ backgroundColor: `${x && x.sampleRef && x.sampleRef[parentIdx] && x.sampleRef[parentIdx].Value === 'OK' ? 'green' : 'red'}` }}> Result : {x.sampleRef && x.sampleRef[parentIdx] && x.sampleRef[parentIdx].Value}</td>}

                                        </>)
                                    }) : <td colSpan={2}>'nodata'</td>}
                                </tr>
                            </tbody> */}
                        </table>
                    </React.Fragment>
                })}
            </>
            : getQualityData(obj, sheet).length > 0 ? <>
                {getQualityData(obj, sheet).map((sample, parentIdx) => {

                    return <React.Fragment>
                        {console.log(sample, "----------------sample-------------")}
                         {renderSetName(sample)}

                        <h4 style={{ fontSize: 15, marginTop: 15 }}>Sample Serial :{config.SampleSerial == "Auto" && config.SampleSerialUnique == "No" ? "Sample #" + (parentIdx + 1) : getNextSample(sample.Sample)}
                            {sample.IsNA?`    -  Not Applicable ( Remarks ) : ${sample.IsNARemarks} `: ""}
                        </h4>
                        <table style={{ tableLayout: 'auto', display: 'table' }} className="small table-sm table-responsive">
                            <thead className='text-center' >
                                <tr>
                                    {getColumns(sheet.TemplateName).map((x => <th>{x.FieldName}</th>))}
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {sample.Standard.map((one, index) => {
                                    const color = config.ResultConfigure.find(x => x.TreatAs == one.Result)
                                    return (
                                        <tr style={
                                            { backgroundColor: color ? color.Color : 'yellow', padding: 0 }
                                        } key={index}>
                                            {getColumns(sheet.TemplateName).map((x => <td >{getDataTypeElement(parentIdx, index, x, one)}</td>))}
                                        </tr>
                                    );
                                })}

                            </tbody>
                        </table>
                        {config.ShowAccuracyResult=="Yes"?
                        <div className='text-center'>  {sample.Standard.length > 0 && <div className='p-2 text-black fw-bold' style={{ backgroundColor: `skyblue` }}> Accuarcy : {handelfinalAccuracy(sample.Standard, parentIdx)}</div>}</div>
                        :
                        <div className='text-center'>  {sample.Standard.length > 0 && <div className='p-2 text-white fw-bold' style={{ backgroundColor: `${handelfinalResult(sample.Standard) === 'OK' ? 'green' : 'red'}` }}> Result : {handelfinalResult(sample.Standard, parentIdx)}</div>}</div>

                    }
                    </React.Fragment>
                })}
            </>
                : <p className='mt-5 small text-center'>No Data</p>
    }


     const handelfinalAccuracy = (data = []) => {
        const onlyOKorNA = data.filter((item) => item.Result === "OK" || item.Result === "NA");
        const hasNG = data.filter((item) => item.Result === "NG");
        return `( ${onlyOKorNA.length} / ${data.length} )` || 0;
      };


    return (
        < >
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            <div className="row">
                <div className="col-sm-4 my-3 form-group">
                    <h6>Item Number: {item.ItemNumber}</h6>
                    {item && item.RefDocs && item.RefDocs.map((ref) => {
                        return (
                            <a
                                onClick={() => openBase64InNewTab(ref.FilePath)}
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ fontSize: 'small', marginLeft: '10px' }}
                            >
                                {ref.DocTitle}
                            </a>
                        );
                    })}
                </div>
                {obj.customFields && obj.customFields.length > 0 && obj.customFields.filter(x => x.FieldName && (!x.FieldName.startsWith('Date_'))).map((field, indext) => (
                    field &&
                    <div key={indext} className="col-sm-3 my-3">
                        <div style={{ height: 18 }} className='row'>
                            <label className="small">{field.FieldName}</label>
                        </div>
                        <div className='row'>
                            <div className="form-group">
                                <input
                                    disabled
                                    value={field.Value || ""}
                                    className="form-control form-control-sm"
                                    name={field.FieldName || ""}
                                    type=""
                                    placeholder={`Enter ${field.FieldName || ""}`}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className='row'>
                {config.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
                    Date &nbsp;:&nbsp; <input disabled value={moment(obj.DateTime).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('date', e.currentTarget.value)} type='date' />
                </div>}
                {config.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
                    Time &nbsp;:&nbsp; <input disabled value={moment(obj.DateTime).format('HH:mm')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('time', e.currentTarget.value)} type='time' />
                </div>}
                {obj.Instrument && obj.Instrument.length > 0 && <div className='col-sm-4 mt-2'>
                    <label>Instrument : </label>
                    <Select
                        disabled
                        mode="multiple"
                        placeholder="Select Instrument"
                        value={obj.Instrument.map(x => { return { label: x.Instrument, value: x.Instrument } }) || []}
                        onChange={(values, all) => {
                            const data = { ...inputData }
                            data.Instrument = all.map(x => { return { Instrument: x.label, InstrumentType: x.type } })
                            setInputData(data)
                        }}
                        style={{ width: '100%' }}
                        options={instruments}
                    />
                </div>}
                {config.ImageCapture && config.ImageCapture == "enable" &&
                    <div className='col-sm-4 mt-2'>
                        <ImageView imageList={getRefDocs().map(x => x.FilePath)} />
                    </div>
                }
            </div>
            <div className='relative' >
                <div className="accordion mt-2" id="accordionParent">
                    {item.Inspection.find(x => x.InspectionName == ChecksheetType) &&
                        item.Inspection.find(x => x.InspectionName == ChecksheetType)
                            .checkSheetTitle.map((sheet, sheetIdx) => AccordianComp(sheet, sheetIdx))}
                </div>
            </div>

            <Modal
                title="Selected Image"
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button
                        key="close"
                        onClick={
                            handleModalClose
                        }
                    >
                        Close
                    </Button>,
                ]}
            >
                {ModalImage && (
                    <img
                        src={ModalImage}
                        alt="Selected"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                        }}
                    />
                )}
            </Modal>
        </>
    );
}
export default DataEntryReportView;